import MainPageDialog from '../../components/dialog'
import { Loader } from '../../components/loader';
import DOMPurify from 'dompurify';

const NotesPreviewPopup = ({ setShowPopup, notesData, isLoadingPreview }) => {
    
    if (isLoadingPreview) {
        return isLoadingPreview && (
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[999]">
                {" "}
                <Loader />
            </div>)
    }

    // Sanitize the HTML to prevent XSS attacks
    const sanitizedHtml = DOMPurify.sanitize(notesData?.preview);

    return (
        <>
            <MainPageDialog
                title="Encounter Preview"
                modalSize="md"
                footerList={[
                    {
                        title: "Close",
                        type: "cancel",
                        action: () => setShowPopup((false)),
                    },
                ]}
                onCancelHandler={() => setShowPopup((false))}
            >
                <p dangerouslySetInnerHTML={{ __html: sanitizedHtml }}></p>
            </MainPageDialog>
        </>
    )
}

export default NotesPreviewPopup